import React from 'react'
import Media from 'react-media'
import bowser from 'bowser'
import { connect } from 'react-redux'
import { message, openSettingsScreen } from 'macguffin/redux/actions'
import { SETTINGSCREENS, MESSAGE_TYPES } from 'macguffin/redux/constants'
import { Component } from 'macguffin/components'
import Replay from './replay'
import ReplayFrame from './replay/frame'
import DefaultSettings from './defaultSettings'
import TitleBar from '../popups/TitleBar'
import { uiButtonPressed } from '../../redux/actions'
import { BUTTON_CLOSE, BUTTON_HOME } from '../../redux/constants'
import config from 'config'
import SvgIcon from '../svg/SvgIcon'
import { stopPropagation } from '../../utils'

@connect(state => ({
  settingScreen: state.base.settingScreen,
  dimensions: state.UI.dimensions,
  replayUrl: state.UI.replayUrl,
}), { message, openSettingsScreen, uiButtonPressed })
export default class UI extends Component {
  constructor(props, context) {
    super(props, context)
    this.rulesSection = React.createRef()
  }

  componentDidMount() {
    this.checkIfRulesPage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.settingScreen !== this.props.settingScreen) {
      this.checkIfRulesPage()
    }
  }

  checkIfRulesPage = () => {
    const { settingScreen } = this.props
    const { RULES } = SETTINGSCREENS
    if (settingScreen === RULES) {
      this.rulesSection.current.scrollIntoView({ block: 'start' })
    }
  }

  openSetting = (setting) => {
    this.outer && (this.outer.scrollTop = 0)
    return () => {
      this.props.openSettingsScreen(setting)
      this.props.uiButtonPressed(setting || BUTTON_CLOSE)
    }
  }

  /*
   * iPad fix for info page scrolled below bottom
   * on screen rotate while content is scrolling
   */
  checkBottomScroll = e => {
    const scrollPosition = e.target.scrollTop
    const scrollHeight = e.target.scrollHeight - e.target.clientHeight
    const scrolledBelowBottom = scrollHeight - scrollPosition < -e.target.clientHeight / 2
    if (scrolledBelowBottom) {
      e.target.scrollTop = scrollHeight
    }
  }

  getContent(centralized, isInfoRulesPage) {
    const { props } = this
    const { settingScreen, dimensions } = props
    const { Info, Settings, Rules } = props.pages
    const { SETTINGS, INFO } = SETTINGSCREENS
    const { desktopUI, portrait, width, availableWidth } = dimensions

    const contentWrapperStyle = desktopUI || portrait ? {} : { paddingRight: `${width - availableWidth + 10}px` }

    return (
      <div className="content-wrapper" onClick={stopPropagation} style={contentWrapperStyle}>
        <div
          className={`content ${centralized ? 'centralized' : ''} ${isInfoRulesPage ? INFO : settingScreen}`}
          ref={e => this.outer = e}
          onScroll={this.checkBottomScroll}
        >
          {isInfoRulesPage && (
            <React.Fragment>
              <Info />
              <div ref={this.rulesSection}></div>
              {!config.hideGameRules && <Rules />}
              {!config.disableShowHistory && <Replay />}
            </React.Fragment>
          )}
          {settingScreen === SETTINGS && (
            <React.Fragment>
              <DefaultSettings />
              <Settings />
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }

  showHomePrompt = () => {
    this.props.message({
      type: MESSAGE_TYPES.HOME_PROMPT,
      noCloseButton: true
    })
    this.props.uiButtonPressed(BUTTON_HOME)
  }

  render() {
    const { openSetting, props } = this
    const { settingScreen, dimensions, replayUrl, svgIcons } = props
    const { INFO, SETTINGS, RULES } = SETTINGSCREENS
    const { desktopUI, portrait, width, availableWidth } = dimensions

    if (replayUrl) {
      return <ReplayFrame {...{ replayUrl, dimensions }} />
    }

    let settingsSufix
    switch (settingScreen) {
      case SETTINGS:
        settingsSufix = 'settings.settings'
        break
      default:
        settingsSufix = 'info.paytable'
        break
    }
    const settingsTitle = `${config.GAME_CONFIG.gameTitle} ${this.t(settingsSufix)}`

    const titleWrapperStyle = desktopUI || portrait ? {} : { padding: `0 ${width - availableWidth + 20}px 0 8%` }

    const isInfoRulesPage = [INFO, RULES].includes(settingScreen)

    return (
      <Media query={{ screen: true, maxWidth: bowser.mobile ? 100000 : 801, orientation: 'landscape' }} >
        {landscape => (
          <div className="settings-wrapper">
            <div className={`settings ${!landscape && 'portrait'}`} onClick={stopPropagation}>
              <div className="title-wrapper settings-title-wrapper" style={titleWrapperStyle}>
                <TitleBar
                  titleText={settingsTitle}
                  svgIcons={svgIcons}
                  enableCloseIcon={desktopUI}
                  closeIconAdditionalClass='settings-close'
                  onCloseIconClick={openSetting(null)}
                />
              </div>
              <div className="menu-wrapper" onClick={openSetting(null)}>
                <div className="menu" onClick={stopPropagation}>
                  <div className={`menu-item ${isInfoRulesPage ? 'active' : ''}`}>
                    <SvgIcon
                      svgIcons={svgIcons}
                      disabled={isInfoRulesPage}
                      iconName={`info${isInfoRulesPage ? '-selected' : ''}`}
                      onClick={openSetting(INFO)}
                      eventsOnContainer={true}
                    />
                  </div>
                  <div className={`menu-item ${settingScreen === SETTINGS ? 'active' : ''}`}>
                    <SvgIcon
                      svgIcons={svgIcons}
                      disabled={settingScreen === SETTINGS}
                      iconName={`settings${settingScreen === SETTINGS ? '-selected' : ''}`}
                      onClick={openSetting(SETTINGS)}
                      eventsOnContainer={true}
                    />
                  </div>
                  {!config.hideHomeButton &&
                    <div className="menu-item">
                      <SvgIcon
                        svgIcons={svgIcons}
                        iconName="home"
                        onClick={this.showHomePrompt}
                        eventsOnContainer={true}
                      />
                    </div>
                  }
                  {!desktopUI &&
                    <div className="menu-item">
                      <SvgIcon
                        svgIcons={svgIcons}
                        iconName="close"
                        additionalClass="settings-close"
                        onClick={openSetting(null)}
                        eventsOnContainer={true}
                      />
                    </div>
                  }
                </div>
              </div>
              {this.getContent(landscape, isInfoRulesPage)}
            </div>
          </div>
        )}
      </Media>
    )
  }
}
